import React, { useState } from 'react';
import { getStartupVerifiedIcon } from 'utils/functions';
import { Skeleton } from '@mui/material';
import { useSelector } from 'react-redux';
import Button from 'components/Buttons/Button';
import { Avatar } from 'xland-ui';
import PopupStartupDetails from 'components/StartupPanel/PopupStartupDetails';

function SummaryStartupProfile() {
  const literals = useSelector(state => state.i18n.literals.home);
  const startup = useSelector(state => state.global.startup);
  const [popupStartupDetails, setPopupStartupDetails] = useState(false);

  if (!startup) {
    return (
      <div className='full-width'>
        <div className='home-profile'>
          <div className='home-profile--left'>
            <Skeleton animation='wave' width={40} height='40px' />

            <div className='home-profile--body'>
              <div title={startup.name} className='home-profile--name'>
                <Skeleton animation='wave' width={100} />
              </div>
              {startup.description && (
                <span className='home-profile--description'>
                  <Skeleton animation='wave' width={400} />
                </span>
              )}
            </div>
          </div>
          <div className='home-profile--actions'>
            <Button color='secondary' text={literals.contact} isDisabled loading />
            <Button color='secondary' text={literals.link} isDisabled loading />
            <Button color='secondary' text={literals.details} isDisabled loading />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className='full-width'>
      <div className='home-profile'>
        <div className='home-profile--left'>
          <Avatar
            title={startup?.name}
            src={startup?.logo?.path}
            size={40}
          />
          <div className='home-profile--body'>
            <div title={startup.name} className='home-profile--name'>
              {startup.name}
              {getStartupVerifiedIcon(startup.verified)}
            </div>
            {startup.description && (
              <span className='home-profile--description'>{startup.description}</span>
            )}
          </div>
        </div>
        <div className='home-profile--actions'>
          <Button
            color='secondary'
            text={literals.contact}
            onClick={() => setPopupStartupDetails(true)}
          />
          <Button
            color='secondary'
            text={literals.link}
            onClick={() => setPopupStartupDetails(true)}
          />
          <Button
            color='secondary'
            text={literals.details}
            onClick={() => setPopupStartupDetails(true)}
          />
        </div>
        {popupStartupDetails && (
          <PopupStartupDetails
            onClose={() => setPopupStartupDetails(false)}
          />
        )}
      </div>
    </div>
  );
}

export default SummaryStartupProfile;
